<template>
    <div id="atmo-top" class="atmo-hash-jump-point" v-if="purchase">
        <section class="atmo-fast-access-menu">
            <ul class="atmo-container-fixed">
                <li><a href="#atmo-customer-info">Информация о заказчике</a></li>
                <li><a href="#atmo-purchase-terms">Условия закупки</a></li>
                <li><a href="#atmo-supplier-requirements">Требования к участникам закупки</a></li>
                <li v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule"><a href="#atmo-supply-terms">Условия поставки</a></li>
                <li><a href="#atmo-notice-deliverables">Спецификация</a></li>
                <li><a href="#explanation-requests">Запросы разъяснений по закупке</a></li>
                <li><a href="#atmo-proposals">Предложения участников закупочной сессии</a></li>
                <li v-if="!!purchase.supplier_proposal"><a href="#atmo-supplier-info">Информация о поставщике</a></li>
                <li v-if="purchase.flags.allow_show_contract"><a href="#atmo-contract">Контракт</a></li>
                <li v-if="purchase.flags.has_contract && purchase.contract && purchase.contract.supplementary_agreements && (purchase.contract.supplementary_agreements.length === 0 && $store.getters.isLoggedIn && purchase.is_customer && purchase.actions.customer.supplementary_agreement !== 'disallow' || purchase.contract.supplementary_agreements.length > 0)"><a href="#atmo-contract-annexes">Дополнительные соглашения</a></li>
                <li v-if="purchase.flags.has_contract_fulfillment"><a href="#atmo-contract-fulfillment">Исполнение контракта</a></li>

                <section class="atmo-group">
                    <li title="К верху страницы">
                        <a class="atmo-button-icon" href="#atmo-top"><i class="atmo-icon-angle-up"></i></a>
                    </li>
                    <li title="К низу страницы">
                        <a class="atmo-button-icon" href="#atmo-bottom"><i class="atmo-icon-angle-down"></i></a>
                    </li>
                </section>
            </ul>
        </section>
        <b-container fluid class="main_layer py-2">
            <b-container>
                <p class="fs-40 fw-600 white-color my-2">Закупка 44ФЗ с неопределённым объёмом - № {{ purchase.reg_number }}</p>
                <p class="white-color fs-14"><b>Статус</b>: {{ purchase.status.title }}</p>
            </b-container>
        </b-container>
        <b-container fluid class="my-2">
            <b-container>
                <text-header id="atmo-customer-info" class="atmo-hash-jump-point">Информация о заказчике</text-header>
                <text-row-link compact :label-cols-lg="4" :label-cols-sm="4" label="Наименование" v-model="purchase.customer.full_name" :router-link="{ name: 'OrganizationShow', params: { id: purchase.customer.id } }" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Рейтинг" :value="$formatPrice(purchase.customer.customer_rating)" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ИНН" v-model="purchase.customer.inn" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="КПП" v-model="purchase.customer.kpp" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ОГРН" v-model="purchase.customer.ogrn" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Юридический адрес" v-model="purchase.customer.legal_address" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительная контактная информация" v-model="purchase.purchase_terms.contact_info" v-if="purchase.purchase_terms.contact_info" />

                <text-header id="atmo-purchase-terms" class="atmo-hash-jump-point">Условия закупки</text-header>
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_terms.deliverable_group.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_terms.purchase_object" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.purchase_terms.order_type.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="purchase.purchase_terms.duration_type.name" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Год ПГ (Плана-графика)" :value="purchase.purchase_terms.purchase_limit_year" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса, %" :value="purchase.purchase_terms.advance_percentage" />
                <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="purchase.purchase_terms.contract_price" />
                <text-row-datetime compact :label-cols-lg="4" :label-cols-sm="4" label="Дата и время размещения закупки" :value="purchase.published_at" />
                <text-row-datetime compact :label-cols-lg="4" :label-cols-sm="4" label="Дата и время окончания приема предложений" :value="purchase.purchase_end" />
                <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.purchase_terms.planned_contract_conclusion_date" />
                <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.purchase_terms.planned_contract_execution_date" />
                <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="purchase.purchase_terms.contract_draft_attachment" />
                <text-row-single-document v-if="purchase.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="purchase.purchase_terms.commercial_proposal_form_attachment" />
                <text-row-documents compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительные документы" v-model="purchase.additional_documents" v-if="purchase.additional_documents.length > 0" />
                <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" :value="purchase.purchase_terms.unilateral_contract_termination_info ?? 'Нет'" text-wrap />

                <text-header id="atmo-supplier-requirements" class="atmo-hash-jump-point">Требования к участникам закупки</text-header>
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.supplier_requirements.only_smp" value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Установить требование к участникам по рейтингу с возможностью отклонения предложения участника с рейтингом ниже 4,5 балла"
                    :value="purchase.supplier_requirements.supplier_reqs_rating"
                    value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_a"
                    value-class="text-right" />
                <b-container v-if="purchase.supplier_requirements.supplier_reqs_a">
                    <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Описание требований" :value="purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text" text-wrap />
                    <b-form-group :label-cols-sm="4" :label-cols-lg="4" label="Подтверждающие документы:" label-class="fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                        <ul>
                            <li v-for="(item, index) in purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents" :key="index" class="fs-14 grey-color my-auto col-form-label pb-0">{{ index + 1 + '. ' + item.name }}</li>
                        </ul>
                    </b-form-group>
                </b-container>
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_b"
                    value-class="text-right" />
                <text-row-boolean-text
                    compact
                    :label-cols-lg="11"
                    :label-cols-sm="11"
                    label="Соответствие участника закупки требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    :value="purchase.supplier_requirements.supplier_reqs_c"
                    value-class="text-right" />
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Участник является социально ориентированной некоммерческой организацией (СОНКО)" :value="purchase.supplier_requirements.supplier_reqs_sonko" value-class="text-right" />
                <text-row-boolean-text compact :label-cols-lg="11" :label-cols-sm="11" label="Дополнительные требования к участникам закупки" :value="purchase.supplier_requirements.has_additional_requirements" value-class="text-right" />
                <div v-show="purchase.supplier_requirements.has_additional_requirements">
                    <section style="width: 100%">
                        <div class="table-responsive">
                            <table class="atmo-content-table mb-0">
                                <thead>
                                <tr>
                                    <th class="atmo-ctc-width-45pct py-1">Описание</th>
                                    <th class="atmo-ctc-width-45pct py-1">Причина или цель установки требования</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="(requirement, index) in purchase.supplier_requirements.additional_requirements" v-bind:key="index">
                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.description }}</td>
                                    <td class="atmo-ctc-width-45pct py-1">{{ requirement.reason }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>

                <template v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule">
                    <text-header id="atmo-supply-terms" class="atmo-hash-jump-point">Условия поставки</text-header>
                    <b-form-group v-if="purchase.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="pt-0 pb-2 fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                        <ul class="pb-2">
                            <li v-for="(address, index) in purchase.delivery_terms.addresses" :key="index" class="py-0 fs-14 grey-color my-auto col-form-label">{{ address }}</li>
                        </ul>
                    </b-form-group>
                    <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.delivery_terms.schedule" />
                </template>

                <form-row-specification-table-view id="atmo-notice-deliverables" class="atmo-hash-jump-point" v-model="purchase.deliverables" without-count />

                <limits-table v-if="$store.getters.isLoggedIn && purchase.is_customer && ! purchase.purchase_terms.without_limits" :items="purchase.limits" />

                <AccordionItem :visible="$route.hash === '#explanation-requests'" title="Запросы разъяснений по закупке" class="atmo-hash-jump-point pb-0" id="explanation-requests">
                    <ExplanationRequestList v-if="!! purchase.id" :purchase-item="purchase" purchase-type="fl44UnknownVolume" />
                </AccordionItem>

                <fl44-unknown-volume-proposals-block :purchase="purchase" />
                <fl44-unknown-volume-summarizing-block v-if="$store.getters.isLoggedIn && purchase.is_customer && purchase.actions.customer.select_winner" :purchase="purchase" @refresh="refresh($event)"/>
                <fl44-unknown-volume-supplier-info-block id="atmo-notice-deliverables" class="atmo-hash-jump-point" v-if="!!purchase.supplier_proposal" :proposal="purchase.supplier_proposal" :show-documents="purchase.is_customer" :is-participant="purchase.flags.is_participant" />
                <fl44-unknown-volume-contract-block v-if="purchase.flags.allow_show_contract" :purchase="purchase" @refresh="refresh($event)" />
                <fl44-unknown-volume-contract-fulfillment-block v-if="purchase.flags.has_contract_fulfillment" :purchase="purchase" @refresh="refresh($event)" />
            </b-container>
        </b-container>
        <b-container fluid class="my-4" id="action_buttons_row">
            <b-container class="mb-5">
                <b-row class="my-3 mt-5">
                    <b-col>
                        <fl44-unknown-volume-download-purchase-pdf-button :purchase-id="purchase.id" :reg-number="purchase.reg_number" />
                        <signature-xml-info-button
                            title="Электронная подпись к извещению"
                            :customer-signature="purchase.signature"
                            :allow-download-xml="purchase.flags.is_participant"
                            :filename="'purchase_signature_info_' + purchase.reg_number"
                            class="mt-2 ml-2" />
                        <fl44-unknown-volume-new-proposal-button :notice-item="purchase" v-if="$store.getters.isLoggedIn" />
                        <fl44-unknown-volume-download-purchase-final-protocol-pdf-button :purchase-id="purchase.id" :reg-number="purchase.reg_number" v-if="purchase.flags.has_final_protocol || this.purchase.status.id === 'failed' || purchase.flags.has_contract" />
                        <template v-if="purchase.flags.has_contract && purchase.status.id !== 'contract:failed'">
                            <fl44-unknown-volume-download-purchase-contract-pdf-button :purchase-id="purchase.id" :reg_number="purchase.reg_number" />
                            <signature-xml-info-button
                                v-if="purchase.contract.customer_signature || purchase.contract.supplier_signature"
                                title="Электронная подпись к контракту"
                                :customer-signature="purchase.contract.customer_signature"
                                :supplier-signature="purchase.contract.supplier_signature"
                                :allow-download-xml="purchase.flags.is_participant"
                                :filename="'purchase_contract_signature_info_' + purchase.reg_number"
                                class="mt-2 ml-2" />
                        </template>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <div id="atmo-bottom" class="atmo-hash-jump-point"></div>
    </div>
</template>

<script>

import ExplanationRequestList from '@/components/purchases/ExplanationRequests/ExplanationRequestList.vue';
import AccordionItem from '@/components/common/accordion-item.vue';
import Fl44UnknownVolumeDownloadPurchasePdfButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-download-purchase-pdf-button.vue';
import Fl44UnknownVolumeProposalsBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-proposals-block.vue';
import Fl44UnknownVolumeNewProposalButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-new-proposal-button.vue';
import Fl44UnknownVolumeSummarizingBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-summarizing-block.vue';
import Fl44UnknownVolumeDownloadPurchaseFinalProtocolPdfButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-download-purchase-final-protocol-pdf-button.vue';
import Fl44UnknownVolumeSupplierInfoBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplier-info-block.vue';
import Fl44UnknownVolumeContractBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-contract-block.vue';
import Fl44UnknownVolumeDownloadPurchaseContractPdfButton from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-download-purchase-contract-pdf-button.vue';
import Fl44UnknownVolumeContractFulfillmentBlock from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-contract-fulfillment-block.vue';
import setFastAccessMenuTopV2 from '@lib/js/src/misc/setFastAccessMenuTopV2';

export default {
    name: 'fl44-unknown-volume-purchase-show',
    components: {
        Fl44UnknownVolumeContractFulfillmentBlock,
        Fl44UnknownVolumeDownloadPurchaseContractPdfButton,
        Fl44UnknownVolumeContractBlock,
        Fl44UnknownVolumeSupplierInfoBlock,
        Fl44UnknownVolumeDownloadPurchaseFinalProtocolPdfButton,
        Fl44UnknownVolumeSummarizingBlock,
        Fl44UnknownVolumeNewProposalButton,
        Fl44UnknownVolumeProposalsBlock,
        Fl44UnknownVolumeDownloadPurchasePdfButton,
        AccordionItem,
        ExplanationRequestList
    },
    metaInfo() {
        return {
            title: 'Закупка 44ФЗ с неопределённым объёмом № ' + this.getRegNumber
        };
    },
    data() {
        return {
            id: this.$route.params.id,
            purchase: null,
        };
    },
    async mounted() {
        await this.fillData();
        setFastAccessMenuTopV2();
        this.$scrollToHash();
    },
    methods: {
        async fillData() {
            this.purchase = await this.$api.products.fl44UnknownVolume.purchases.show(this.id);
        },
        async refresh(newHash = null) {
            if (newHash !== null) {
                await this.$router.replace({ name: 'Fl44UnknownVolumePurchaseShow', params: { id: this.id }, hash: newHash });
            }
            await this.fillData();
            if (newHash !== null) {
                this.$scrollToHash();
            }
        }
    },
    computed: {
        getRegNumber() {
            return this.purchase?.reg_number ?? '';
        }
    }
};
</script>

<style scoped>
.main_layer {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100px;
}
.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}
.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    color: var(--grey-color);
    border-top: 0;
}
.table tbody tr {
    border-bottom: 1px solid #dee2e6;
}
</style>
